import React from "react";

import dictionaryConfig from "@/../config/dictionary.config";
import Link from "next/link";
import { SupPool } from "@repo/core-ui";
import { SupAssetLabel, SupText, SupTooltip } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";

import UiLabelSuperPoolTooltip from "@/components/Ui/Label/SuperPool/Tooltip";

interface UiLabelSuperPoolTagProps {
  isSmall?: boolean;
  showTooltip?: boolean;
}
export default function UiLabelSuperPoolTag({ isSmall, showTooltip = false }: UiLabelSuperPoolTagProps) {
  const linkElement = (
    <Link className="inline-flex flex-none justify-center" href={dictionaryConfig.superPools.helpArticle} target="_blank">
      <SupAssetLabel
        className={twMerge("w-fit items-center gap-0.5 rounded-full border-0.5 border-primary-500 bg-primary-50 p-0.5 pr-1", isSmall ? "h-5" : "h-6")}
        label={
          <SupText variant="caption" className="text-primary-800">
            SuperPool
          </SupText>
        }
      >
        <SupPool className={twMerge(isSmall ? "h-4 w-4" : "h-5 w-5", "text-primary-800")} />
      </SupAssetLabel>
    </Link>
  );

  return showTooltip ? (
    <SupTooltip portal unmount content={<UiLabelSuperPoolTooltip />} color="default" popperElClassName="bg-neutral">
      {linkElement}
    </SupTooltip>
  ) : (
    linkElement
  );
}
